import type { DetailsPanelContentCreatedDateQueryType } from '@confluence/details-panel-shared-queries';

export const normalizeContentCreatedData = (data?: DetailsPanelContentCreatedDateQueryType) => ({
	date: data?.content?.nodes?.[0]?.metadata.createdDate,
});
